import { render, staticRenderFns } from "./SettingsAvatar.vue?vue&type=template&id=6ad44af7"
import script from "./SettingsAvatar.vue?vue&type=script&lang=js"
export * from "./SettingsAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports